import { InfiniteData } from '@tanstack/query-core';
import { useMutation } from '@tanstack/react-query';
import { ProgramsData } from '@shared/types/programs';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useDeleteProgramMutation = () => {
  return useMutation({
    mutationFn: async (params: EntityByIdParam) => await API.programs.delete(params),
    onSuccess: (response, { id }) => {
      queryClient.setQueriesData(
        { queryKey: ['programsHistory'] },
        (oldData: InfiniteData<ProgramsData>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: [...page.results.filter((item) => item.pk !== Number(id))],
            })),
          };
        }
      );

      queryClient.setQueriesData(
        { queryKey: ['programs'] },
        (oldData: InfiniteData<ProgramsData>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: [...page.results.filter((item) => item.pk !== Number(id))],
            })),
          };
        }
      );
      queryClient.invalidateQueries({ queryKey: ['programs'] });
      queryClient.invalidateQueries({ queryKey: ['programsHistory'] });
    },
  });
};
